/**
 * Thinking Indicator Component - OmniMind style
 * Mirrors the reasoning trace card shown on a finished answer, so the wait
 * looks like the first steps of the answer rather than a separate spinner.
 */

import React from 'react';

const STEPS = [
  { label: 'Resolving the question', source: 'OmniMind', color: '#D97757', tag: 'OM' },
  { label: 'Selecting sources and tools', source: 'planner', color: '#6D5AE6', tag: 'SL' },
  { label: 'Querying connected systems', source: 'agents', color: '#2354F0', tag: 'AG' },
];

export const ThinkingIndicator: React.FC = () => {
  return (
    <div className="amsg">
      <span className="av2">
        <i />
      </span>
      <div className="body">
        <div className="think">
          <div className="h">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
              <path d="M12 3v3M12 18v3M3 12h3M18 12h3" />
              <rect x="7" y="7" width="10" height="10" rx="3" />
            </svg>
            <span>Working on it</span>
            <span className="t">live</span>
          </div>
          {STEPS.map((step, i) => (
            <div className={`st${i === STEPS.length - 1 ? ' run' : ''}`} key={step.label}>
              <span className="ico" style={{ background: step.color }}>
                {step.tag}
              </span>
              <span>
                {step.label} <span className="dim">· {step.source}</span>
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
